import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _debounce from 'lodash/debounce';
import _isEmpty from 'lodash/isEmpty';
import _map from 'lodash/map';
import PropTypes from 'prop-types';
// Core components
import Box from 'components/core/Box';
import Select from 'components/core/Select';
import TextField from 'components/core/TextField';
// Custom
import { listFeatureSearchFieldShape } from 'constants/PropTypesShapes';
import { invoke } from 'utils/Tools';
import { CloseIconButton } from 'components/buttons/IconButtons';
import { DisabledContext } from 'components/misc/Contexts';

class TextFieldFilter extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    const { value, onChange } = this.props;
    this.performChange = _debounce(onChange, 500);

    this.state = {
      value,
    };
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props;
    const { value: prevValue } = prevProps;
    // Catch change from parent
    if (prevValue !== value) {
      invoke(() => {
        this.setState({ value });
      });
    }
  }

  // Handlers
  handleChange(value) {
    this.setState({ value }, () => this.performChange(value));
  }

  render() {
    const {
      label, operator, searchField, onOperatorChange,
    } = this.props;
    const { value } = this.state;

    return (
      <DisabledContext.Consumer>
        {(disabled) => (
          <TextField
            id={label}
            disabled={disabled}
            label={<LocalizedMessage id={label} />}
            value={value}
            onChange={this.handleChange}
            adornments={{
              start: (searchField && searchField.withOperators) ? (
                <Box type="defaultBackground">
                  <Select
                    margin="none"
                    maxWidth={140}
                    disabled={disabled}
                    fullWidth={false}
                    disableUnderline
                    value={operator}
                    items={_map(searchField.type.operators, (op) => ({
                      key: op,
                      labelId: `filter.operator.${op}`,
                      value: op,
                    }))}
                    onChange={onOperatorChange}
                  />
                </Box>
              ) : null,
              end: !_isEmpty(value) ? (
                <CloseIconButton onClick={() => this.handleChange('')} tooltipId="tooltip.empty" />
              ) : null,
            }}
          />
        )}
      </DisabledContext.Consumer>
    );
  }
}

TextFieldFilter.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  operator: PropTypes.string,
  searchField: listFeatureSearchFieldShape,
  onChange: PropTypes.func.isRequired,
  onOperatorChange: PropTypes.func,
};

TextFieldFilter.defaultProps = {
  value: '',
  operator: null,
  searchField: null,
  onOperatorChange: null,
};

module.exports = TextFieldFilter;



// WEBPACK FOOTER //
// ./components/filters/TextFieldFilter.js